import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import './AdminLogin.css';

// Generic login card shared by every game. Each game passes its own `auth`
// instance so credentials are checked against that game's Firebase project.
const AdminLogin = ({
  auth,
  title = 'Admin Login',
  footnote,
  errorMessage = 'Failed to sign in. Check credentials.',
  busyLabel = 'Signing in...',
}) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError(errorMessage);
      console.error(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-login-screen">
      <div className="card admin-login-card">
        <h1 className="admin-login-title">{title}</h1>
        <form onSubmit={handleLogin}>
          <div className="admin-login-field">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              required
            />
          </div>
          <div className="admin-login-field admin-login-field-last">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              required
            />
          </div>
          {error && <p className="admin-login-error">{error}</p>}
          <button type="submit" className="btn btn-primary admin-login-submit" disabled={busy}>
            {busy ? busyLabel : 'Log In'}
          </button>
        </form>
        {footnote && <p className="admin-login-footnote">{footnote}</p>}
      </div>
    </div>
  );
};

export default AdminLogin;
